'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { useEffect as x } from "react";
import { FontAwesomeIcon as g } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faCircleCheck as f } from "../../external/@fortawesome/pro-light-svg-icons/index.js";
const j = ({
  password: l,
  validPassword: a
}) => {
  const i = [
    "Password strength",
    "Weak",
    "Moderate",
    "moderate",
    "Strong"
  ], o = [
    "bg-grey-200",
    "bg-[#ae0b0b]",
    "bg-[#ffc400]",
    "bg-[#ffc400]",
    "bg-[#90d3b7]"
  ], c = [
    { label: "At least 8 characters", regex: /.{8,}/ },
    { label: "At least one small letter", regex: /[a-z]/ },
    { label: "At least one capital letter", regex: /[A-Z]/ },
    { label: "At least one number or symbol", regex: /[\d\W]/ }
  ], t = c.reduce(
    (r, s) => r + (s.regex.test(l) ? 1 : 0),
    0
  ), n = Array(5).fill(o[0]), m = t >= 4 ? 5 : t;
  return n.fill(o[t], 0, m), x(() => {
    a(t >= 4);
  }, [t, a]), /* @__PURE__ */ e.jsxs("div", { className: "w-full", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex space-x-1", children: n.map((r, s) => /* @__PURE__ */ e.jsx(
      "div",
      {
        className: `h-1 w-1/5 rounded-full ${r} transition-opacity duration-300`
      },
      s
    )) }),
    /* @__PURE__ */ e.jsx("div", { className: "p-1 text-right text-xs text-grey-400", children: i[t] }),
    /* @__PURE__ */ e.jsx("div", { className: "mt-4 rounded-lg border border-grey-300 p-4", children: /* @__PURE__ */ e.jsx("ul", { className: "text-grey-600 list-inside list-disc text-sm", children: c.map(({ label: r, regex: s }, d) => /* @__PURE__ */ e.jsxs(
      "li",
      {
        className: `flex items-center text-grey-400 ${s.test(l) ? " font-semibold" : "font-normal "}`,
        children: [
          /* @__PURE__ */ e.jsx(
            g,
            {
              icon: f,
              className: `mr-2 ${s.test(l) ? "text-[#90d3b7]" : "text-grey-200"}`
            }
          ),
          r
        ]
      },
      d
    )) }) })
  ] });
};
export {
  j as default
};
